import React, { useState } from 'react';
import { Checkbox } from '@mantine/core';
import { useDispatch, useSelector } from 'react-redux';
import { change, Field } from 'redux-form';
import Button from '../../elements/Button';
import ImagePicker from '../../elements/ImagePicker/ImagePicker';
import LoadingBars from '../../elements/LoadingBars';
import IconDownloadCsv from '../../icons/IconDownloadCsv';
import styles from './styles.scoped.css';
import PropTypes from 'prop-types';
import Banner from '../../elements/Banner';
import IconFailed from '../../icons/IconFailed';
import { MIME_TYPES } from '@mantine/dropzone';
import { useNavigate } from 'react-router-dom';
import TextArea from '../../fields/TextArea';

export default function Component({
  handleSubmit,
  isLoading,
  isTooManyRequests,
  minute = '00',
  second = '00',
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [file, setFile] = useState([]);
  const { values } = useSelector((state) => state.form.FormNikActivatedBulk);
  const [error, setError] = useState('');
  const [supportDocument, setSupportDocument] = useState(null);

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit({
      ...values, file, supportDocument
    });
  };

  const downloadTemplate = () => {
    window.open('https://storage.googleapis.com/fin-map-images-public-stage/templates/Template_list_NIK.csv');
  };

  const propsfile = {
    title: 'Dokumen Pendukung',
    name: 'file',
    maxSize: 20000000,
    info: 'Format file .doc, .docx atau .pdf dan tidak lebih dari 2 Mb',
    require: true
  };

  const onSelect = (e) => {
    setSupportDocument(e[0]);
  };

  return (
    <form className={styles.form} onSubmit={onSubmit}>
      <div className={styles.card}>
        <ImagePicker
          accept={['text/csv']}
          downloadTemplate={downloadTemplate}
          IconDownloadTemplate={<IconDownloadCsv />}
          info={'Format file .csv dan tidak lebih dari 2 Mb'}
          maxSize={2000000}
          onSelect={setFile}
          required={true}
          title={'Unggah Data Pelanggan'}
          withDownloadTemplate={true}
        />
        <Field
          component={TextArea}
          inputProps={{
            label: 'Alasan Aktifkan Pelanggan',
            placeholder: 'Masukkan alasan mengaktifkan NIK pelanggan'
          }}
          name="activateReason"
          onChange={(e) => change('FormNikActivatedBulk', 'activateReason', e.target.value)}
          required
          rows={4}
          styles={{
            input: {
              minHeight: '80px',
              fontSize: '14px',
              padding: '10px 12px',
            },
          }}
        />
        <ImagePicker
          accept={[MIME_TYPES.pdf, MIME_TYPES.doc, MIME_TYPES.docx]}
          {...propsfile}
          errorMessage={error}
          maxSize={2000000}
          onSelect={onSelect}
          // required
          setErrorMessage={setError}
        />
        <Field
          component={Checkbox}
          label="Saya yakin untuk mengaktifkan NIK pelanggan ini"
          name="agree"
          onClick={(e) => dispatch(change('FormNikActivatedBulk', 'agree', e.target.checked))}
          styles={{
            body: {
              alignItems: 'center'
            },
            label: {
              color: '#212121',
              fontWeight: 400,
              fontSize: '14px'
            }
          }}
        />
      </div>
      {isTooManyRequests
        && (
          <Banner
            className={styles.banner}
            desc={<>
              Sudah submit CSV 5 kali dalam satu menit.
              Anda dapat submit file CSV kembali setelah <strong>{minute}:{second}</strong></>}
            icon={<IconFailed />}
            type="danger" />
        )}
      <div className={styles.actions}>
        <Button
          fullWidth
          onClick={() => navigate('/customer-setting')} outlined>
          Kembali
        </Button>
        <Button
          className={styles.btnAction}
          disabled={!values.agree || file.length === 0 || !values.activateReason
             || isLoading || isTooManyRequests}
          fullWidth
          style={'blue'}
          type="submit">
          {isLoading && <LoadingBars size={1} />}
          Submit
        </Button>
      </div>
    </form>
  );
}

Component.propTypes = {
  handleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  isTooManyRequests: PropTypes.bool,
  minute: PropTypes.string,
  second: PropTypes.string,
};
